export default "__VITE_ASSET__FgJ3HAVv__"